import PropTypes from 'prop-types';
import { useMemo } from 'react';
import {
   ThemeProvider as MUIThemeProvider,
   createTheme,
   StyledEngineProvider,
} from '@mui/material/styles';
import typography from './typography';
import ComponentsOverrides from './overRides';
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react';

export default function ThemeProvider({ children }) {
   const themeOptions = useMemo(
      () => ({ typography:typography }),[typography]);
      const cache = createCache({key:'secondary'})
      const theme = createTheme(themeOptions);
      theme.components = ComponentsOverrides(theme)
   return (
      <CacheProvider value={cache}>
      <StyledEngineProvider injectFirst>
         <MUIThemeProvider theme={theme}>
            {children}
         </MUIThemeProvider>
      </StyledEngineProvider>
      </CacheProvider>
   );
}
